module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_courier_service":"Select courier service"},"id":{"select_courier_service":"Pilih layanan kurir"}}')
  delete Component.options._Ctor
}
